import { useState, useEffect, useMemo } from 'react';
import { createSearchEngine, searchProverbs, Proverb } from '../utils/searchEngine';

export const useSearch = (proverbs: Proverb[]) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<Proverb[]>(proverbs);

  // Create Fuse instance once when proverbs change
  const fuse = useMemo(() => {
    return createSearchEngine(proverbs);
  }, [proverbs]);

  // Perform search when query changes
  useEffect(() => {
    if (!query || query.trim().length < 2) {
      setResults(proverbs);
    } else {
      const searchResults = searchProverbs(fuse, query);
      setResults(searchResults);
    }
  }, [query, proverbs, fuse]);

  return {
    query,
    setQuery,
    results,
    totalCount: proverbs.length,
    resultsCount: results.length,
    isSearching: query.trim().length >= 2
  };
};
